import script from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=05b6eb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b6eb30"]])

export default __exports__